import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BrandIcon } from './BrandIcon';

interface BrandLogoLinkProps {
  size?: 'sm' | 'md';
  className?: string;
}

export function BrandLogoLink({ size = 'md', className = '' }: BrandLogoLinkProps) {
  const { t } = useTranslation();
  const iconSize = size === 'sm' ? 36 : 38;

  return (
    <Link
      to="/"
      className={`shrink-0 transition-opacity hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-room-accent ${className}`}
      aria-label={t('legal.backToHome')}
      title={t('common.appName')}
    >
      <BrandIcon size={iconSize} />
    </Link>
  );
}
